import { useMemo } from 'react';
import fileConfig from '../../entity-config.json';

export type TEntityConfig = {
  VITE_ENTITY: string;
  VITE_URL_TRADING_API: string;
  VITE_URL_ID_BACKEND: string;
  VITE_URL_ID_FRONTEND: string;
  VITE_URL_PERSISTENCE_SERVICE: string;
  VITE_APPLICATION_TITLE: string;
  VITE_URL_CREATE_ACCOUNT: string;
  VITE_ALL_SETTINGS_LOCAL: boolean;
  VITE_URL_CHART_SERVICE: string;
  VITE_APPLICATION_EXCHANGE: string;
  VITE_CLIENT_PORTAL_SUPPORTED_LOCALES: string[];
  VITE_REPLAY_APPLY_SAVED_LAYOUT: boolean;
  VITE_REPLAY_MIN_DATE: string;
  VITE_URL_TRADING_VIEW: string;
  VITE_ACCOUNT_MASK: boolean;
};

export const defaultConfig: TEntityConfig = {
  VITE_ENTITY: '',
  VITE_URL_TRADING_API: '',
  VITE_URL_ID_BACKEND: '',
  VITE_URL_ID_FRONTEND: '',
  VITE_URL_PERSISTENCE_SERVICE: '',
  VITE_APPLICATION_TITLE: '',
  VITE_URL_CREATE_ACCOUNT: '',
  VITE_ALL_SETTINGS_LOCAL: false,
  VITE_URL_CHART_SERVICE: '',
  VITE_APPLICATION_EXCHANGE: '',
  VITE_CLIENT_PORTAL_SUPPORTED_LOCALES: [],
  VITE_REPLAY_APPLY_SAVED_LAYOUT: false,
  VITE_REPLAY_MIN_DATE: '',
  VITE_URL_TRADING_VIEW: '',
  VITE_ACCOUNT_MASK: false,
};

export const getEntityConfig = (): TEntityConfig => {
  try {
    const parsedConfig = fileConfig[window.location.hostname as keyof typeof fileConfig];

    if (!parsedConfig) {
      console.error(`Unknown config for ${window.location.hostname}`);

      return defaultConfig;
    }

    const config = {
      VITE_ENTITY: import.meta.env.VITE_ENTITY || parsedConfig.VITE_ENTITY,
      VITE_URL_TRADING_API: import.meta.env.VITE_URL_TRADING_API || parsedConfig.VITE_URL_TRADING_API,
      VITE_URL_ID_BACKEND: import.meta.env.VITE_URL_ID_BACKEND || parsedConfig.VITE_URL_ID_BACKEND,
      VITE_URL_ID_FRONTEND: import.meta.env.VITE_URL_ID_FRONTEND || parsedConfig.VITE_URL_ID_FRONTEND,
      VITE_URL_PERSISTENCE_SERVICE:
        import.meta.env.VITE_URL_PERSISTENCE_SERVICE || parsedConfig.VITE_URL_PERSISTENCE_SERVICE,
      VITE_APPLICATION_TITLE: import.meta.env.VITE_APPLICATION_TITLE || parsedConfig.VITE_APPLICATION_TITLE,
      VITE_URL_CREATE_ACCOUNT: import.meta.env.VITE_URL_CREATE_ACCOUNT || parsedConfig.VITE_URL_CREATE_ACCOUNT,
      VITE_ALL_SETTINGS_LOCAL:
        (import.meta.env.VITE_ALL_SETTINGS_LOCAL && import.meta.env.VITE_ALL_SETTINGS_LOCAL === 'true') ||
        parsedConfig.VITE_ALL_SETTINGS_LOCAL,
      VITE_URL_CHART_SERVICE: import.meta.env.VITE_URL_CHART_SERVICE || parsedConfig.VITE_URL_CHART_SERVICE,
      VITE_APPLICATION_EXCHANGE: import.meta.env.VITE_APPLICATION_EXCHANGE || parsedConfig.VITE_APPLICATION_EXCHANGE,
      VITE_CLIENT_PORTAL_SUPPORTED_LOCALES:
        import.meta.env.VITE_CLIENT_PORTAL_SUPPORTED_LOCALES || parsedConfig.VITE_CLIENT_PORTAL_SUPPORTED_LOCALES,
      VITE_REPLAY_APPLY_SAVED_LAYOUT:
        (import.meta.env.VITE_REPLAY_APPLY_SAVED_LAYOUT && import.meta.env.VITE_REPLAY_APPLY_SAVED_LAYOUT === 'true') ||
        parsedConfig.VITE_REPLAY_APPLY_SAVED_LAYOUT,
      VITE_REPLAY_MIN_DATE: import.meta.env.VITE_REPLAY_MIN_DATE || parsedConfig.VITE_REPLAY_MIN_DATE,
      VITE_URL_TRADING_VIEW: import.meta.env.VITE_URL_TRADING_VIEW || parsedConfig.VITE_URL_TRADING_VIEW,
      VITE_ACCOUNT_MASK:
        (import.meta.env.VITE_ACCOUNT_MASK && import.meta.env.VITE_ACCOUNT_MASK === 'true') ||
        parsedConfig.VITE_ACCOUNT_MASK,
    };

    return config;
  } catch (error) {
    console.error('Failed to load entity configuration', error);

    return defaultConfig;
  }
};

export const useEntityConfig = (): TEntityConfig => {
  const config = useMemo(() => {
    return getEntityConfig();
  }, []);

  return config;
};
